const apiPaths = {
  account: accountId => `${apiPaths.accounts}${accountId}/`,
  accountOrders: '/account-orders/',
  accountPaymentProfile: (accountId, profileId) => `${apiPaths.accountPaymentProfiles(accountId)}${profileId}/`,
  accountPaymentProfiles: accountId => `${apiPaths.accounts}${accountId}${apiPaths.paymentProfiles}`,
  accountProduct: id => `${apiPaths.accountProducts}${id}/`,
  accountProductComments: id => `${apiPaths.accountProduct(id)}comments/`,
  accountProductPrices: '/account-product-prices/',
  accountProducts: '/account-products/',
  accounts: '/accounts/',
  addresses: '/addresses/',
  authorizeCreditCards: '/authorize-credit-cards/',
  availableFilters: '/available-filters/',
  bulkPricing: '/bulk-pricing/',
  categories: '/categories/',
  contactForms: '/contact-forms/',
  contactFormSubjects: '/contact-form-subjects/',
  contactGroups: '/contact-groups/',
  contact: id => `${apiPaths.contacts}${id}/`,
  contacts: '/directory/',
  countries: '/countries/',
  credits: '/credits/',
  creditsSummaries: '/credits/summaries/',
  defaultBulk: '/items/?default_bulk_only=true',
  defaultSwag: '/pack-templates/?default_pack_only=true',
  deliveryMethods: '/delivery-methods/',
  design: id => `${apiPaths.designs}${id}/`,
  designOrders: id => `${apiPaths.design(id)}orders/`,
  designs: '/designs/',
  employeeOrder: id => `${apiPaths.employeeOrders}${id}/`,
  employeeOrders: '/employee-orders/',
  individualPackPrices: '/shipping-prices/individual-packs/',
  inventory: '/stock/',
  invoice: id => `${apiPaths.invoices}${id}/`,
  invoicePayments: id => `${apiPaths.invoice(id)}payments/`,
  invoices: '/invoices/',
  metadata: '/public-metadata/',
  notifications: '/notifications/', // removed notifications components, if they are used this commit can be undone
  opportunities: '/opportunities/',
  opportunity: id => `${apiPaths.opportunities}${id}/`,
  opportunityProofs: id => `${apiPaths.opportunity(id)}proofs/`,
  orders: '/orders/',
  packMultiplePrice: '/pack-multiple-price/',
  packTemplates: '/pack-templates/',
  partners: '/partners/',
  paymentProfiles: '/payment-profiles/',
  process: id => `${apiPaths.processes}${id}/`,
  processes: '/processes/',
  processOutput: (processId, outputId) => `${apiPaths.processOutputs(processId)}${outputId}/`,
  processOutputs: id => `${apiPaths.process(id)}outputs/`,
  profile: id => `${apiPaths.profiles}${id}/`,
  profiles: '/profiles/',
  proof: id => `${apiPaths.proofs}${id}/`,
  proofComments: id => `${apiPaths.proof(id)}comments/`,
  proofPrices: '/proof-prices/',
  proofs: '/proofs/',
  samplePacks: '/sample-packs/',
  samplePacksEmails: '/sample-packs/emails/',
  saveContacts: '/save-contacts/',
  shipmentGroup: (oppId, groupId) => `${apiPaths.shipmentGroups(oppId)}${groupId}/`,
  shipmentGroups: oppId => `${apiPaths.opportunity(oppId)}shipments/`,
  shippingPrices: '/shipping-prices/',
  sizes: '/sizes/',
  storageCategories: '/storage-categories/',
  storagePrices: '/storage-prices/',
  subscribers: '/subscribers/',
  swagContacts: '/swag-contacts/',
  transactions: '/transactions/',
  updateContactsSizes: '/output-contact-sizes/',
  warehouseProofs: oppId => `${apiPaths.opportunity(oppId)}warehouse-proofs/`
};

export default apiPaths;
